<template>
  <div>
    <el-card>
      <el-input
        style="width: 250px"
        v-model="studentName"
        placeholder="请输入"
      ></el-input>
      <el-button
        style="margin-left: 20px"
        type="goon"
        @click.native="GetWxDetailInfoByPage"
        >查询</el-button
      >
      <el-button style="margin-left: 20px" type="goon" @click="onClickAdd"
        >新增</el-button
      >
      <el-button style="margin-left: 20px" type="goon" @click.native="onReset"
        >清空</el-button
      >
    </el-card>
    <el-card style="margin-top: 20px">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{
          background: '#F2F5FF',
          color: '#333',
          'text-align': 'center',
        }"
        border
      >
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="内容类型" align="center">
          <template slot-scope="scope">
            {{
              scope.row.Type == 1
                ? "首次关注"
                : scope.row.Type == 2
                ? "渠道码"
                : "自动回复"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="Name" label="名称" align="center">
        </el-table-column>
        <el-table-column prop="Num" label="编号" align="center">
        </el-table-column>
        <el-table-column label="渠道码地址" align="center">
          <template slot-scope="scope">
            <el-link
              @click="onClickRoute(scope.row.QRCode)"
              type="primary"
              :underline="false"
            >
              {{ scope.row.QRCode }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column label="文章类型" align="center">
          <template slot-scope="scope">
            {{ scope.row.MsgType == "image" ? "图片" : "文字" }}
          </template>
        </el-table-column>
        <el-table-column prop="Content" label="内容" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.MsgType == 'text'">
              {{ scope.row.Content }}
            </div>
            <el-image
              v-if="scope.row.MsgType == 'image'"
              style="width: 100px; height: 100px"
              :src="scope.row.Image"
              :preview-src-list="[scope.row.Image]"
              fit="cover"
            ></el-image>
          </template>
        </el-table-column>

        <el-table-column prop="CreateTime" label="创建时间" align="center">
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template slot-scope="scope">
            <div>
              <el-button
                type="text"
                style="color: #4083fe"
                @click="onClickEdit(scope.row)"
                >编辑</el-button
              >

              <el-button
                type="text"
                @click="onClickDelete(scope.row)"
                style="color: #e14747"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="PageIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center;padding:20px; 0 0 0"
      >
      </el-pagination>
    </el-card>
    <el-dialog :title="Title" :visible.sync="dialogVisible" width="30%">
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          label-position="top"
        >
          <el-table-column label="序号" align="center" width="50">
            <template slot-scope="scope">
              {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
            </template>
          </el-table-column>
          <el-form-item label="内容类型" prop="Type">
            <el-radio-group v-model="ruleForm.Type">
              <el-radio label="1">1.首次关注</el-radio>
              <el-radio label="2">2.渠道码</el-radio>
              <el-radio label="3">3.自动回复</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="编号" prop="Num" v-if="ruleForm.Type != '1'">
            <el-input v-model="ruleForm.Num" type="number"></el-input>
          </el-form-item>
          <el-form-item label="名称" prop="Name" v-if="ruleForm.Type != '1'">
            <el-input v-model="ruleForm.Name"></el-input>
          </el-form-item>

          <el-form-item label="文章类型" prop="MsgType">
            <el-select
              v-model="ruleForm.MsgType"
              placeholder="请选择文章类型"
              @change="onChangeMsg"
            >
              <el-option label="text" value="text"></el-option>
              <el-option label="image" value="image"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="内容" prop="Content" v-if="ruleType == 'text'">
            <el-input
              type="textarea"
              :autosize="{ minRows: 15, maxRows: 30 }"
              v-model="ruleForm.Content"
            ></el-input>
          </el-form-item>

          <el-form-item label="内容" prop="Content" v-if="ruleType == 'image'">
            <el-upload
              class="avatar-uploader"
              action="/api/mgd/WxMain/UploadMultimedia"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
              :data="MainId"
            >
              <img v-if="ruleForm.Image" :src="ruleForm.Image" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addSubmit('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetWxDetailInfoByPage,
  AddWxDetailInfo,
  DeleteWxDetailInfo,
  UploadMultimedia,
} from "../../api/api";
export default {
  data() {
    return {
      tableData: [],
      total: 0,
      PageSize: 10,
      PageIndex: 1,
      studentName: "",
      dialogVisible: false,
      Title: "",
      ruleForm: {
        Id: 0,
        Name: "-",
        Num: 0,
        Type: "",
        MsgType: "",
        Content: "",
        QRCode: "-",
        Image: "",
      },
      rules: {
        Name: [{ required: true, message: "请输入渠道名称", trigger: "blur" }],
        Num: [{ required: true, message: "请输入渠道编号", trigger: "blur" }],
        Type: [
          { required: true, message: "请选择文字类型", trigger: "change" },
        ],
        MsgType: [
          { required: true, message: "请选择文章类型", trigger: "change" },
        ],
        Content: [{ required: true, message: "请输入内容", trigger: "blur" }],
      },
      ruleType: "text",
      MainId: { Id: 0 },
    };
  },
  created() {
    this.GetWxDetailInfoByPage();
  },
  methods: {
    onClickRoute(e) {
      if (e != "") {
        window.open(e, "_blank");
      }
    },
    handleAvatarSuccess(res, file) {
      this.ruleForm.Image = res.response.url;
      this.ruleForm.Content = res.response.media_id;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    onChangeMsg(e) {
      this.ruleType = e;
      this.ruleForm.Content = "";
      this.ruleForm.Image = "";
      this.MainId.Id = this.$route.query.Id;
    },
    //   详情
    onClickDetail() {
      this.$router.push({
        path: "/Official/detail",
      });
    },
    onDataTest() {
      this.ruleForm = {
        MainId: 0,
        Name: "-",
        Num: 0,
        Type: "",
        MsgType: "",
        Content: "",
        QRCode: "-",
        Image: "",
      };
    },
    //   编辑
    async onClickEdit(row) {
      this.Title = "编辑";
      //console.log(row);
      this.MainId.Id = row.MainId;

      this.ruleType = row.MsgType;
      this.ruleForm = {
        Id: row.Id,
        Name: row.Name,
        Num: row.Num,
        Type: row.Type + "",
        MsgType: row.MsgType,
        Content: row.Content,
        QRCode: "-",
        Image: row.Image,
      };

      this.dialogVisible = true;
    },
    //   删除
    async onClickDelete(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = await DeleteWxDetailInfo({ ids: [row.Id] });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.GetWxDetailInfoByPage();
        } else {
          this.$message({
            type: "error",
            message: "删除失败!",
          });
        }
      });
    },
    addSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.AddWxDetailInfo();
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    async AddWxDetailInfo() {
      this.ruleForm.MainId = this.$route.query.Id;
      let res = await AddWxDetailInfo(this.ruleForm);
      if (res.data.success) {
        this.$message({
          type: "success",
          message: "新增成功",
        });
        this.GetWxDetailInfoByPage();
        this.dialogVisible = false;
      } else {
        this.$message({
          type: "error",
          message: "新增失败",
        });
      }
    },
    onClickAdd() {
      this.Title = "新增";
      this.onDataTest();
      this.dialogVisible = true;
    },
    onReset() {
      this.studentName = "";
      this.PageIndex = 1;
      this.GetWxDetailInfoByPage();
    },
    async GetWxDetailInfoByPage() {
      let res = await GetWxDetailInfoByPage({
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        Name: this.studentName,
        MainId: this.$route.query.Id,
      });
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetPhysicalExaminationList();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.GetPhysicalExaminationList();
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

/deep/.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

/deep/.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
</style>